export enum AuthenticationStatus {
    SUCCESS = 'SUCCESS',
    AUTHENTICATION_INVALID = 'AUTHENTICATION_INVALID',
    CONFIGURATION_INVALID = 'CONFIGURATION_INVALID',
    ON_PREMISES_ACCOUNT_CONFIGURATION_INVALID = 'ON_PREMISES_ACCOUNT_CONFIGURATION_INVALID',
    SCOPES_INVALID = 'SCOPES_INVALID',
    ERROR = 'ERROR',
}
